/*
  TODO: When migration from maxim to tnow is completed and we decommission tedig7456GeneralRequestMaximToTnow feature flag,
  this wrapper component is no longer required. Hence we will decommission this too.
*/

import * as React from "react";
import { getServiceRequestFlags } from "@telstra-connect/service-requests/feature-flags/load-flags";
import { Navigate, useLocation } from "react-router-dom";
import { MaximQuestionComponentForGeneralRequest } from "./general-requests-question-component-lazy";
import { Routing } from "@apps-config";
import { secureRouteBuilder } from "../../../secure-route";
import Routes from "../../route-constants";

const routes = new Routing.RoutesHelper({
    rootPath: secureRouteBuilder(Routes.Open),
    subpagesPathMask: secureRouteBuilder(Routes.ServiceRequests),
});

// Route mapping for redirection
const maximToTnowRouteMapping = {
    [routes.getPageSubpath(Routes.maximFormURL)]:
    routes.getPageSubpath(Routes.mobilitySolutionsURL),
    [routes.getPageSubpath(Routes.maximFormFromMobileServicesPage)]:
    routes.getPageSubpath(
        Routes.mobilitySolutionsFromMobileServicesPage
    ),
} as const;

const GeneralRequestMaximToTnowRoute = () => {
    const { state, pathname } = useLocation();

    // Find the matching route for redirection
    const maximRoute = Object.keys(maximToTnowRouteMapping).find(
        (routeKey: string) => pathname.endsWith(routeKey)
    );

    const isFeatureEnabled =
    getServiceRequestFlags().featureFlags.tedig7456GeneralRequestMaximToTnow;

    // Check if the feature flag is enabled and a matching route is found
    if (isFeatureEnabled && maximRoute) {
        return (
            <Navigate
                to={maximToTnowRouteMapping[maximRoute]}
                state={state}
                replace={true}
            />
        );
    }

    // Render the main component if no redirection is needed
    return <MaximQuestionComponentForGeneralRequest />;
};

export default GeneralRequestMaximToTnowRoute;
